import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { RegistrationFieldsApi } from '../../../apis/RegistrationFieldsApi/RegistrationFieldsApi.ts';

export function useGetFacilityRegistrationFields(facilityId: number | null | undefined) {
    return useQuery({
        queryKey: [QueryKeys.facilityRegistrationFields, facilityId],
        queryFn: () => RegistrationFieldsApi.getByFacility(facilityId as number),
        enabled: !!facilityId && facilityId > 0,
    });
}
